import { SavedFilters } from './../reduxTypes';

const cleanState = {
  savedMarket: []
};

const initialState: SavedFilters = {
  ...cleanState
};

interface ReduxProps {
  type: string;
  value: any;
}

export default (state = initialState, { type, value }: ReduxProps): any => {
  switch (type) {
    case 'SET_SAVED_MARKET_FILTERS':
      return {
        ...state,
        savedMarket: value
      };
    default:
      return state;
  }
};
